// extracted by mini-css-extract-plugin
export var section = "styles-module--section--EXRzu";
export var container = "styles-module--container--+rul4";
export var content = "styles-module--content--7-med";
export var title = "styles-module--title--ZAv4o";
export var image = "styles-module--image--wgx6L";